module.exports = __webpack_public_path__ + "img/icon-question-radiobutton.f1be8c96.svg";